import { styled } from '@mui/system';
import { useState } from 'react';
import { AuthLayout } from '../../layout';
import { Page } from '../../components/Page';
import { Register } from '../../features/onboarding';
import { RegisterTour } from '../../features/onboarding/components/Tour';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const RegisterPage = () => {
  const [runTour, setRunTour] = useState(false);

  const handleStartTour = () => {
    setRunTour(true);
  };

  const handleFinishTour = () => {
    setRunTour(false);
  };

  return (
    <RootStyle title="ManageMate | Register">
      <AuthLayout>
        <RegisterTour runTour={runTour} handleFinishTour={handleFinishTour} />
        <Register handleStartTour={handleStartTour} />
      </AuthLayout>
    </RootStyle>
  );
};

export default RegisterPage;
